const FROST = 'https://froststream.cloutteam.com/manifest.json';
const TORRENTIO_PT = 'https://torrentio.strem.fun/providers=comando,bludv,micoleaodublado%7Clanguage=portuguese/manifest.json';
function managedTransport(url, origin = window.location.origin) {
    if (url === FROST) return `${origin}/api/addon-resources/frost/manifest.json`;
    return url;
}
module.exports = { managedTransport, FROST, TORRENTIO_PT };
